

export enum AffixRespondEvents {
  resize = 'resize',
  scroll = 'scroll',
  touchstart = 'touchstart',
  touchmove = 'touchmove',
  touchend = 'touchend',
  pageshow = 'pageshow',
  load = 'LOAD'
}
